'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  diameter: _reactackleCore.doubleBaseModule,
  fontSize: _reactackleCore.fontSizeXsmall,

  style: {
    fontColor: _reactackleCore.colorPaletteGrey500,
    backgroundColor: _reactackleCore.colorPaletteGrey200,

    hover: {
      fontColor: _reactackleCore.colorPaletteGrey700,
      backgroundColor: _reactackleCore.colorPaletteGrey400
    },

    focus: {
      fontColor: _reactackleCore.colorPaletteGrey500,
      backgroundColor: _reactackleCore.colorPaletteGrey900
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tooltip-icon/dist/styles/theme.js
// module id = 879
// module chunks = 0